import { css } from 'styled-components';
import FormInputsProStyle from "../templates/FormInputs.style";
import InputHzeroStyle from "../templates-hzero/Input.style";
var FormInputStyle = css(["", ""], FormInputsProStyle);
var inputData = {
  name: 'input',
  data: [{
    radius: 2,
    border: 'all',
    // 边框： all | [bottom, top, left, ...]
    borderWidth: 1,
    borderWidthFocused: 2,
    borderColor: '#e8e8e8',
    fontColor: '#1C1C1C',
    fontSize: 12,
    lineHeight: 20,
    disabledBorderColor: '#E8E8E8',
    disabledBgColor: '#F5F5F5',
    disabledFontColor: '#686868',
    inputHeight: 28,
    inputFontWeight: '500',
    background: '#fff',
    // Form
    // labelAlign: 'left',
    formInputHeight: 50,
    formInputOtherHeight: 34,
    labelFontSize: 12,
    labelBackGround: 'transparent',
    baseLabelFontColor: '#7C859B',
    emptyLabelFontColor: '#9EADBE',
    focusedLabelFontColor: '#5365EA',
    errorShadow: '0 0 3px 0  rgb(255 249 251)',
    errorColor: '#F45063',
    errorBorderColor: '#F45063',
    errorFontColor: '#1C1C1C',
    errorTitleColor: '#F45063',
    errorBgColor: 'rgb(255 249 251)',
    errorAllBgColor: 'rgb(255 249 251)',
    errorFocusBorderbottom: '.02rem solid #FD729C',
    labelCol: 24,
    formCol: 24,
    focusIconColor: '#0840f8',
    focusBordertop: '#0840f8',
    focusBorderbottom: '.02rem solid #0840f8',
    focusBorderleft: '#0840f8',
    focusBorderright: '#0840f8',
    groupAddonBackground: '.02rem solid #F2F2F2',
    groupAddonPadding: '0rem 0.08rem',
    groupAddonBorder: '.01rem solid #E8E8E8',
    floatMargin: '0 0 .2rem 0',
    floatCloseIcon: '\\E5C9',
    floatCloseIconHoverColor: '#9EADBE',
    floatMutipleItemBackground: '#rgba(83,101,234,0.08)',
    floatMutipleItemColor: '#415BC9',
    cursorBackgroundColor: 'transparent',
    textAndMutiplePaddingTop: '.15rem',
    mutiplePaddingLeft: '.04rem',
    mutipleBorderRadius: '.02rem',
    mutipleInputPaddingTop: '0rem',
    mutiSelectItemFontSize: 12,
    selectPaddingLeft: '.1rem',
    inputPaddingTop: '.20rem',
    inputWrapperBorderRadius: 2,
    mutipleIconColor: '#415BC9',
    mutipleErrorBgColor: 'rgba(253,114,156,0.1)',
    floatLabelWith: 'auto',
    floatLabelTop: '.15rem',
    floatLabelLeft: '.03rem',
    floatLabelMarginLeft: '0',
    floatLabelMarginTop: '0',
    floatPrefixLeft: '.24rem',
    floatTextAreaPadding: '0',
    floatTextAreaPosition: 'relative',
    floatTextAreaTop: '.12rem',
    floatNumberInputButtonIconVertical: 'sub',
    PrefixSuffixColor: '#7C859B',
    numberInputButtonMargin: '0',
    numberInputButtonHeight: '100%',
    numberInputButtonWidth: 26,
    numberInputButtonTop: '0',
    numberInputButtonRight: '0',
    numberInputButtonIconHeight: '50%',
    numberInputButtonHeightItem: '.13rem',
    numberInputButtonIconBorder: '1px solid #E8E8E8',
    numberInputButtonIconColor: '#7C859B',
    numberInputButtonIconMargin: '0',
    numberInputButtonIconBorderLeft: '1px solid #E8E8E8',
    numberInputButtonIconBorderFirstTop: 'none',
    numberInputButtonIconBorderLastBottom: 'none',
    suffixWidth: 30,
    addPadding: 0,
    iconFontSize: 14,
    noPadding: 0,
    normalPadding: 4,
    verticalLabelPaddingLeft: 8,
    verticalWrapperPaddingLeft: 8,
    verticalWrapperPaddingBottom: 8,
    colonWidth: 4
  }],
  onlyTemplate: {
    pro: FormInputsProStyle,
    hzero: InputHzeroStyle
  }
};
export default inputData;